import { getClassName } from "@pairtreefamily/utils";

export type ProfilePlaceholderProps = {
  alt?: string;
  className?: string;
};

export function ProfilePlaceholder(props: ProfilePlaceholderProps) {
  const className = getClassName("relative", "bg-teal", props.className);

  return (
    <div className={className}>
      <img
        className="relative left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]"
        width={83}
        src="/profile_placeholder.svg"
        alt={props.alt ?? ""}
      />
    </div>
  );
}

export default ProfilePlaceholder;
